<footer class="footer">
    <div class="row">
        <div class="col-md-6">
            <p class="text-left ml-1 mt-3">
                Maps version {{version}} sa
            </p>
        </div>
        <div class="col-md-3 text-right">
        </div>
        <div class="col-md-3 text-right float-right ">
            <img src="./assets/img/maps-positive.png" class="mt-2 mr-2 logo-footer float-right" [hidden]="theme === 'negative'">
            <img src="./assets/img/maps-negative.png" class="mt-2 mr-2 logo-footer" [hidden]="theme === 'positive'">
        </div>
    </div>
</footer>
